<template>
  <div>
    <div v-if="!mobileMenu" class="nav-bar">
      <router-link
        tag="a"
        active-class="active"
        :to="{ name: 'CustomerDetails' }"
      >
        <div class="nav_item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="48"
            height="45.384"
            viewBox="0 0 48 45.384"
          >
            <g id="Expanded" transform="translate(0 -2.616)">
              <g id="Group_4" data-name="Group 4">
                <g id="Group_1" data-name="Group 1">
                  <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M42,48H28V35H20V48H6V27a1,1,0,0,1,2,0V46H18V33H30V46H40V28a1,1,0,0,1,2,0Z"
                  />
                </g>
                <g id="Group_2" data-name="Group 2">
                  <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M47,27a1,1,0,0,1-.691-.277L24,5.384,1.691,26.723A1,1,0,0,1,.308,25.278L24,2.616,47.691,25.277A1,1,0,0,1,47,27Z"
                  />
                </g>
                <g id="Group_3" data-name="Group 3">
                  <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M39,15a1,1,0,0,1-1-1V8H32a1,1,0,0,1,0-2h8v8A1,1,0,0,1,39,15Z"
                  />
                </g>
              </g>
            </g>
          </svg>
          Home
        </div>
      </router-link>
      <router-link tag="a" active-class="active" :to="{ name: 'MakePayment' }">
        <div class="nav_item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="40"
            height="44"
            viewBox="0 0 40 44"
          >
            <g id="Expanded" transform="translate(-4 -2)">
              <g id="Group_9" data-name="Group 9">
                <g id="Group_5" data-name="Group 5">
                  <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M24,20C12.785,20,4,16.047,4,11s8.785-9,20-9,20,3.953,20,9S35.215,20,24,20ZM24,4C15.486,4,6,6.875,6,11s9.486,7,18,7,18-2.875,18-7S32.514,4,24,4Z"
                  />
                </g>
                <g id="Group_6" data-name="Group 6">
                  <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M24,28C12.785,28,4,24.047,4,19V11a1,1,0,0,1,2,0v8c0,4.125,9.486,7,18,7s18-2.875,18-7V11a1,1,0,0,1,2,0v8C44,24.047,35.215,28,24,28Z"
                  />
                </g>
                <g id="Group_7" data-name="Group 7">
                  <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M24,37C12.785,37,4,33.047,4,28V19a1,1,0,0,1,2,0v9c0,4.125,9.486,7,18,7s18-2.875,18-7V19a1,1,0,0,1,2,0v9C44,33.047,35.215,37,24,37Z"
                  />
                </g>
                <g id="Group_8" data-name="Group 8">
                  <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M24,46C12.785,46,4,42.047,4,37V28a1,1,0,0,1,2,0v9c0,4.125,9.486,7,18,7s18-2.875,18-7V28a1,1,0,0,1,2,0v9C44,42.047,35.215,46,24,46Z"
                  />
                </g>
              </g>
            </g>
          </svg>
          Make a Payment
        </div>
      </router-link>
      <router-link
        tag="a"
        active-class="active"
        :to="{ name: 'PaymentHistory' }"
      >
        <div class="nav_item">
          <svg
            class="icon"
            viewBox="0 0 475 475"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g class="Extended">
              <path
                id="svg_1"
                d="M 251.231 448 L 102.912 446.764 C 104.747 412.697 103.039 64 103.039 64 L 381.434 64 L 381.434 217.172 C 381.434 223.33 388.1 227.179 393.434 224.1 C 395.909 222.671 397.434 220.03 397.434 217.172 L 397.434 56 C 397.435 51.581 393.852 47.999 389.434 48 L 95.039 48 C 90.62 47.999 87.038 51.581 87.039 56 C 87.039 56 88.228 450.39 87.996 460.637 C 87.98 461.336 92.459 462.764 93.158 462.764 L 251.231 464 C 257.389 464 261.238 457.333 258.159 452 C 256.73 449.525 254.089 448 251.231 448 Z"
              />
              <path
                id="svg_2"
                d="M 333.996 148.766 L 150.476 148.766 C 144.318 148.766 140.469 155.432 143.548 160.766 C 144.977 163.241 147.618 164.766 150.476 164.766 L 333.996 164.766 C 340.155 164.766 344.004 158.099 340.924 152.766 C 339.495 150.29 336.854 148.766 333.996 148.766 Z"
              />
              <path
                id="svg_3"
                d="M 341.996 210.969 C 341.997 206.55 338.415 202.968 333.996 202.969 L 150.476 202.969 C 144.318 202.969 140.469 209.635 143.548 214.969 C 144.977 217.444 147.618 218.969 150.476 218.969 L 333.996 218.969 C 338.415 218.97 341.997 215.388 341.996 210.969 Z"
              />
              <path
                id="svg_4"
                d="M 262.231 265.172 C 262.232 260.753 258.649 257.171 254.231 257.172 L 150.477 257.172 C 144.318 257.172 140.469 263.839 143.548 269.172 C 144.977 271.647 147.618 273.172 150.477 273.172 L 254.231 273.172 C 258.649 273.173 262.232 269.591 262.231 265.172 Z"
              />
              <path
                id="svg_5"
                d="M 150.477 311.375 C 144.318 311.375 140.469 318.042 143.548 323.375 C 144.977 325.85 147.618 327.375 150.477 327.375 L 215.731 327.375 C 221.889 327.375 225.738 320.708 222.659 315.375 C 221.23 312.9 218.589 311.375 215.731 311.375 L 150.477 311.375 Z"
              />
              <path
                id="svg_6"
                d="M 436.727 287.461 C 380.536 231.171 284.481 256.817 263.828 333.625 C 263.008 336.675 262.328 339.761 261.791 342.873 L 255.434 336.516 C 251.079 332.161 243.645 334.154 242.051 340.102 C 241.311 342.862 242.1 345.807 244.121 347.828 L 262.53 366.236 C 265.661 369.353 270.722 369.353 273.853 366.236 L 292.266 347.828 C 296.62 343.474 294.628 336.039 288.68 334.445 C 285.919 333.706 282.974 334.495 280.953 336.516 L 279.136 338.332 C 296.326 273.334 377.432 251.319 425.127 298.705 C 472.822 346.09 451.335 427.338 386.45 444.95 C 356.229 453.153 323.929 444.549 301.793 422.398 C 297.439 418.044 290.004 420.036 288.41 425.984 C 287.671 428.745 288.46 431.69 290.481 433.711 C 346.8 489.974 442.905 464.171 463.471 387.266 C 473.006 351.609 462.814 313.573 436.727 287.461 Z"
              />
              <path
                id="svg_7"
                d="M 363.606 291.32 C 359.187 291.319 355.604 294.901 355.606 299.32 L 355.606 360.586 C 355.618 362.708 356.462 364.742 357.956 366.25 L 386.949 395.242 C 391.331 399.568 398.753 397.528 400.309 391.57 C 401.021 388.841 400.243 385.938 398.262 383.93 L 371.606 357.274 L 371.606 299.32 C 371.607 294.901 368.024 291.319 363.606 291.32 Z"
              />
            </g>
          </svg>
          Payment
          <br />History
        </div>
      </router-link>
      <router-link tag="a" active-class="active" :to="{ name: 'Settlement' }">
        <div class="nav_item">
          <svg class="icon" viewBox="0 0 450 450">
            <path
              d="M255.997,67.839c-103.754,0-188.161,84.413-188.161,188.167s84.407,188.155,188.161,188.155  c103.76,0,188.167-84.401,188.167-188.155S359.757,67.839,255.997,67.839z M255.997,414.481  c-87.383,0-158.476-71.093-158.476-158.476c0-87.395,71.092-158.487,158.476-158.487c87.389,0,158.487,71.093,158.487,158.487  C414.485,343.388,343.386,414.481,255.997,414.481z"
            />
            <path
              d="M281.016,174.529c14.806,0,18.867,10.739,22.929,23.522l13.938-17.707c-4.645-18.587-17.422-29.611-42.967-29.611  c-43.845,0-49.066,31.931-49.066,59.794v30.205H204.36l-5.803,24.391h25.835c-3.193,32.811-11.612,63.575-34.261,90.582h125.146  V325.51H244.71c9.002-20.621,12.498-38.614,13.948-60.389h48.479l5.81-24.391h-53.134v-24.391  C259.813,193.698,260.979,174.529,281.016,174.529z"
            />
          </svg>
          Settlement
        </div>
      </router-link>
      <span style="flex-grow: 1"></span>

      <router-link tag="a" active-class="active" :to="{ name: 'Contact' }">
        <div class="nav_item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="icon"
            version="1.1"
            viewBox="0 0 512 512"
            xml:space="preserve"
          >
            <g class="st2" id="layer">
              <g class="st0">
                <path
                  class="st1"
                  d="M305.989,359.513c0,0-2.375-32.569,5.408-38.409c23.362-17.522,100.801-8.773,115.922,16.14    c12.7,20.925,4.435,72.46-12.151,86.932c-6.96,6.073-36.078,8.325-36.078,8.325c-78.748-1.229-150.286-31.834-204.024-81.283    l-14.822-14.738c-49.729-53.436-80.506-124.57-81.743-202.875c0,0,2.264-28.956,8.371-35.876    c14.555-16.492,66.382-24.711,87.425-12.083c25.054,15.036,33.853,92.039,16.23,115.269c-5.872,7.74-38.626,5.378-38.626,5.378"
                />
                <path
                  class="st1"
                  d="M306.12,359.39c-39.6-13.083-74.731-35.871-102.549-65.532l14.356,14.275    c-29.83-27.66-52.748-62.594-65.904-101.97"
                />
              </g>
            </g>
            <g id="layer_copy">
              <path
                d="M434.158,333.092c-9.802-16.148-35.668-23.274-50.215-26.086c-26.549-5.13-60.764-4.74-77.348,7.698   c-5.459,4.097-8.178,12.563-8.813,27.452c-0.084,1.962-0.121,3.878-0.131,5.693c-28.178-10.883-54.189-27.118-76.389-47.683   l-9.749-9.694c-20.652-22.044-36.964-47.872-47.903-75.845c1.829-0.009,3.76-0.046,5.738-0.129   c14.942-0.631,23.439-3.33,27.551-8.75c12.455-16.417,12.906-50.315,7.828-76.626c-2.815-14.591-9.979-40.531-26.315-50.335   c-16.252-9.754-41.371-7.401-51.417-5.935c-20.725,3.021-37.967,10.344-46.124,19.586c-7.108,8.055-9.605,31.042-10.348,40.55   c-0.02,0.25-0.027,0.507-0.023,0.758c1.223,77.447,31.015,151.402,83.886,208.214c0.071,0.075,0.143,0.181,0.216,0.254   l14.822,14.801c0.073,0.073,0.147,0.271,0.224,0.339C226.771,409.916,301.107,439,378.965,441c0.041,0,0.083,0,0.124,0   c0.206,0,0.412-0.258,0.618-0.273c9.55-0.739,32.636-3.469,40.721-10.523c9.302-8.116,16.671-25.277,19.713-45.907   C441.615,374.294,443.984,349.282,434.158,333.092z M424.312,381.962c-2.391,16.212-8.179,30.754-14.396,36.179   c-2.787,2.297-17.248,5.247-31.076,6.354c-73.738-1.243-144.123-29.31-198.244-79.062l-14.6-14.519   c-50.022-53.803-78.239-123.763-79.489-197.06c1.105-13.715,4.063-28.065,6.364-30.833c5.469-6.196,20.111-11.958,36.436-14.338   c17.123-2.497,32.787-1.033,40.875,3.822c7.804,4.684,15.023,19.876,18.839,39.649c5.008,25.95,2.982,53.224-4.697,63.7   c-3.101,2.178-17.161,3.345-30.349,2.556c-1.432-0.361-2.979-0.337-4.484,0.165c-1.314,0.439-2.438,1.187-3.32,2.135   c-1.271,1.305-2.107,3.047-2.249,5.007c-0.122,1.689,0.293,3.291,1.096,4.646c11.06,32.332,28.753,62.276,51.766,87.73   c0.272,0.435,0.59,0.85,0.954,1.238c2.371,2.527,4.794,5.007,7.263,7.433c2.445,2.461,4.941,4.874,7.49,7.236   c0.391,0.362,0.808,0.678,1.244,0.947c25.59,22.873,55.694,40.465,88.193,51.458c1.354,0.8,2.954,1.213,4.643,1.086   c1.973-0.143,3.724-0.994,5.03-2.282c0.134-0.126,0.254-0.264,0.38-0.399c0.034-0.039,0.069-0.078,0.104-0.118   c0.705-0.792,1.28-1.72,1.634-2.791c0.497-1.503,0.517-3.045,0.153-4.473c-0.787-13.079,0.378-27.013,2.556-30.091   c10.622-7.701,38.23-9.693,64.483-4.62c19.729,3.813,34.894,10.97,39.572,18.678C425.351,349.417,426.818,364.962,424.312,381.962z   "
              />
            </g></svg
          >Contact Us
        </div>
      </router-link>
      <a href="#" @click="logout" style="margin-bottom: 10px">Log out</a>
    </div>

    <div class="bg-white b-blue p-2 relative" v-else>
      <svg
        @click="menuOpen = !menuOpen"
        class="cursor-pointer"
        height="32px"
        viewBox="0 0 32 32"
        width="32px"
      >
        <path
          d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
        />
      </svg>
      <div
        class="
          absolute
          bg-white
          top-100
          w-screen
          ml--2
          b-blue
          flex flex-col
          text-left
          p-4
        "
        v-if="menuOpen"
      >
        <router-link
          tag="a"
          class="border-b p-2"
          active-class="active-mobile"
          :to="{ name: 'CustomerDetails' }"
          >Customer Details</router-link
        >
        <router-link
          tag="a"
          class="border-b p-2"
          active-class="active-mobile"
          :to="{ name: 'MakePayment' }"
          >Make a Payment</router-link
        >
        <router-link
          tag="a"
          class="border-b p-2"
          active-class="active-mobile"
          :to="{ name: 'PaymentHistory' }"
          >Payment History</router-link
        >
        <router-link
          tag="a"
          class="border-b p-2"
          active-class="active-mobile"
          :to="{ name: 'Settlement' }"
          >Settlement</router-link
        >
        <router-link
          tag="a"
          class="border-b p-2"
          active-class="active-mobile"
          :to="{ name: 'Contact' }"
          >Contact Us</router-link
        >
        <a class="border-b p-2" href="#" @click="logout">Log out</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      menuOpen: false,
    };
  },

  watch: {
    $route() {
      this.menuOpen = false;
    },
  },

  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$http.post(`Authenticate/ping?message=Click:LogOut`);
      this.$router.push({ name: "Login" });
    },
  },

  computed: {
    mobileMenu() {
      return this.$mq === "sm";
    },
  },
};
</script>

<style scoped>
.ml--2 {
  margin-left: -0.5rem;
}

.b-blue {
  border-bottom: 3px solid #41b3a3;
}

.top-100 {
  top: 100%;
}

.nav-bar a {
  text-decoration: none;
  color: #aaaaaa;
}

.nav-bar {
  border-right: 5px solid #41b3a3;
  width: 100px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  min-height: -webkit-fill-available;
}

.nav-bar .nav_item {
  height: 100px;
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nav-bar .nav_item img {
  height: 30px;
  width: 30px;
  margin-bottom: 7px;
}

.nav-bar .nav_item .icon {
  fill: #aaaaaa;
  height: 30px;
  width: 30px;
  margin-bottom: 7px;
}

.active-mobile {
  color: #505050 !important;
  font-weight: bold;
}

.active {
  color: #505050 !important;
  border-left: 5px solid #41b3a3 !important;
}

.active .nav_item {
  margin-left: 0px;
}

.active .nav_item svg {
  fill: #505050 !important;
}
</style>